import { render } from "./page-loading.vue?vue&type=template&id=e7956de4&scoped=true"
import script from "./page-loading.vue?vue&type=script&lang=js"
export * from "./page-loading.vue?vue&type=script&lang=js"

import "./page-loading.vue?vue&type=style&index=0&id=e7956de4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2424817344/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7956de4"],['__file',"src/components/page-loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e7956de4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e7956de4', __exports__)) {
    console.log('reload')
    api.reload('e7956de4', __exports__)
  }
  
  module.hot.accept("./page-loading.vue?vue&type=template&id=e7956de4&scoped=true", () => {
    console.log('re-render')
    api.rerender('e7956de4', render)
  })

}


export default __exports__